module.exports = __webpack_public_path__ + "img/Pellets-Sackware-Loose-Ware.314c891.png";